const BASE = '/assets/sticker';

const stickerUrl = (theme, category, fileName) => `${BASE}/${theme}/${category}/${fileName}`;

const JELLY_ORNAMENTS = [
  { assetName: 'sticker_jelly_balloon_orange.png', key: 'balloon', label: '풍선' },
  { assetName: 'sticker_jelly_bow_pink.png', key: 'bow', label: '리본' },
  { assetName: 'sticker_jelly_chick_yellow.png', key: 'chick', label: '병아리' },
  { assetName: 'sticker_jelly_cloud_blue.png', key: 'cloud', label: '구름' },
  { assetName: 'sticker_jelly_clover_green.png', key: 'clover', label: '클로버' },
  { assetName: 'sticker_jelly_crown_yellow.png', key: 'crown', label: '왕관' },
  { assetName: 'sticker_jelly_diamond_blue.png', key: 'diamond', label: '다이아' },
  { assetName: 'sticker_jelly_dog_blue.png', key: 'dog', label: '강아지' },
  { assetName: 'sticker_jelly_flower_purple.png', key: 'flower', label: '꽃' },
  { assetName: 'sticker_jelly_heart_pink.png', key: 'heart-pink', label: '하트 핑크' },
  { assetName: 'sticker_jelly_heart_red.png', key: 'heart-red', label: '하트 레드' },
  { assetName: 'sticker_jelly_panda_white.png', key: 'panda', label: '판다' },
  { assetName: 'sticker_jelly_planet_blue_ring.png', key: 'planet', label: '행성' },
  { assetName: 'sticker_jelly_speech_bubble_purple.png', key: 'speech-bubble', label: '말풍선' },
  { assetName: 'sticker_jelly_star_yellow.png', key: 'star', label: '별' },
  { assetName: 'sticker_jelly_bear_brown.png', key: 'bear', label: '곰' },
  { assetName: 'sticker_jelly_cat_pink.png', key: 'cat', label: '고양이' },
  { assetName: 'sticker_jelly_frog_green.png', key: 'frog', label: '개구리' },
  { assetName: 'sticker_jelly_rabbit_white.png', key: 'rabbit', label: '토끼' }
];

const CUTE_ORNAMENTS = [
  { assetName: 'sticker_cute_balloon_purple.png', key: 'balloon', label: '풍선' },
  { assetName: 'sticker_cute_bear_brown.png', key: 'bear', label: '곰' },
  { assetName: 'sticker_cute_bow_yellow.png', key: 'bow', label: '리본' },
  { assetName: 'sticker_cute_cat_blue.png', key: 'cat', label: '고양이' },
  { assetName: 'sticker_cute_cloud_blue.png', key: 'cloud', label: '구름' },
  { assetName: 'sticker_cute_clover_green.png', key: 'clover', label: '클로버' },
  { assetName: 'sticker_cute_crown_gold.png', key: 'crown', label: '왕관' },
  { assetName: 'sticker_cute_flower_pink.png', key: 'flower', label: '꽃' },
  { assetName: 'sticker_cute_fox_orange.png', key: 'fox', label: '여우' },
  { assetName: 'sticker_cute_frog_green.png', key: 'frog', label: '개구리' },
  { assetName: 'sticker_cute_heart_red.png', key: 'heart', label: '하트' },
  { assetName: 'sticker_cute_house.png', key: 'house', label: '집' },
  { assetName: 'sticker_cute_rabbit_pink.png', key: 'rabbit', label: '토끼' },
  { assetName: 'sticker_cute_ribbon_pink.png', key: 'ribbon', label: '리본 줄' },
  { assetName: 'sticker_cute_smile_yellow.png', key: 'smile', label: '스마일' },
  { assetName: 'sticker_cute_sparkle_blue.png', key: 'sparkle-blue', label: '반짝 블루' },
  { assetName: 'sticker_cute_sparkle_pink.png', key: 'sparkle-pink', label: '반짝 핑크' },
  { assetName: 'sticker_cute_speech_bubble_purple.png', key: 'speech-bubble', label: '말풍선' },
  { assetName: 'sticker_cute_star_yellow.png', key: 'star', label: '별' },
  { assetName: 'sticker_cute_tulip_orange.png', key: 'tulip', label: '튤립' }
];

const OUTLINE_ORNAMENTS = [
  { assetName: 'sticker_outline_balloon_purple.png', key: 'balloon', label: '풍선' },
  { assetName: 'sticker_outline_bear_pink.png', key: 'bear', label: '곰' },
  { assetName: 'sticker_outline_burst_lime.png', key: 'burst', label: '버스트' },
  { assetName: 'sticker_outline_cat_blue.png', key: 'cat', label: '고양이' },
  { assetName: 'sticker_outline_checker_star_blue_black.png', key: 'checker-star', label: '체커 별' },
  { assetName: 'sticker_outline_cloud_blue.png', key: 'cloud', label: '구름' },
  { assetName: 'sticker_outline_clover_green.png', key: 'clover', label: '클로버' },
  { assetName: 'sticker_outline_dog_cream.png', key: 'dog', label: '강아지' },
  { assetName: 'sticker_outline_double_star_pink.png', key: 'double-star', label: '더블 스타' },
  { assetName: 'sticker_outline_flower_blue.png', key: 'flower-blue', label: '꽃 블루' },
  { assetName: 'sticker_outline_flower_purple_star_center.png', key: 'flower-purple-star', label: '꽃 스타' },
  { assetName: 'sticker_outline_flower_yellow.png', key: 'flower-yellow', label: '꽃 옐로우' },
  { assetName: 'sticker_outline_frog_green.png', key: 'frog', label: '개구리' },
  { assetName: 'sticker_outline_heart_pink.png', key: 'heart-pink', label: '하트 핑크' },
  { assetName: 'sticker_outline_heart_red.png', key: 'heart-red', label: '하트 레드' },
  { assetName: 'sticker_outline_lightning_orange.png', key: 'lightning', label: '번개' },
  { assetName: 'sticker_outline_music_note_purple.png', key: 'music-note', label: '음표' },
  { assetName: 'sticker_outline_polka_heart_black_pink.png', key: 'polka-heart', label: '도트 하트' },
  { assetName: 'sticker_outline_rabbit_white.png', key: 'rabbit', label: '토끼' },
  { assetName: 'sticker_outline_smile_flower_blue.png', key: 'smile-flower', label: '스마일 꽃' },
  { assetName: 'sticker_outline_smile_star_yellow.png', key: 'smile-star', label: '스마일 별' },
  { assetName: 'sticker_outline_sparkle_yellow.png', key: 'sparkle', label: '반짝' },
  { assetName: 'sticker_outline_speech_bubble_pink.png', key: 'speech-bubble', label: '말풍선' },
  { assetName: 'sticker_outline_star_pink.png', key: 'star', label: '별' },
  { assetName: 'sticker_outline_starburst_orange.png', key: 'starburst', label: '스타버스트' }
];

const AUORA_ORNAMENTS = [
  { assetName: 'sticker_auora_balloon_lavender.png', key: 'balloon', label: '풍선' },
  { assetName: 'sticker_auora_bear_face.png', key: 'bear', label: '곰' },
  { assetName: 'sticker_auora_bow_pink.png', key: 'bow', label: '리본' },
  { assetName: 'sticker_auora_cloud_iridescent.png', key: 'cloud', label: '구름' },
  { assetName: 'sticker_auora_clover_mint.png', key: 'clover', label: '클로버' },
  { assetName: 'sticker_auora_crown_gold.png', key: 'crown', label: '왕관' },
  { assetName: 'sticker_auora_flower_pink.png', key: 'flower', label: '꽃' },
  { assetName: 'sticker_auora_heart_pink.png', key: 'heart', label: '하트' },
  { assetName: 'sticker_auora_house_pastel.png', key: 'house', label: '집' },
  { assetName: 'sticker_auora_smiley_face.png', key: 'smile', label: '스마일' },
  { assetName: 'sticker_auora_sparkle_iridescent.png', key: 'sparkle', label: '반짝' },
  { assetName: 'sticker_auora_speech_auora_blue.png', key: 'speech-bubble', label: '말풍선' },
  { assetName: 'sticker_auora_star_pastel.png', key: 'star', label: '별' },
  { assetName: 'sticker_auora_streamer_pink.png', key: 'streamer', label: '스트리머' }
];

const BLUE_ORNAMENTS = [
  { assetName: 'sticker_blue_balloon_blue.png', key: 'balloon', label: '풍선' },
  { assetName: 'sticker_blue_bear_blue.png', key: 'bear', label: '곰' },
  { assetName: 'sticker_blue_bow_blue.png', key: 'bow', label: '리본' },
  { assetName: 'sticker_blue_cat_blue.png', key: 'cat', label: '고양이' },
  { assetName: 'sticker_blue_checker_heart_blue.png', key: 'checker-heart', label: '체커 하트' },
  { assetName: 'sticker_blue_cloud_blue.png', key: 'cloud', label: '구름' },
  { assetName: 'sticker_blue_clover_blue.png', key: 'clover', label: '클로버' },
  { assetName: 'sticker_blue_computer_blue.png', key: 'computer', label: '컴퓨터' },
  { assetName: 'sticker_blue_crown_blue.png', key: 'crown', label: '왕관' },
  { assetName: 'sticker_blue_dog_blue.png', key: 'dog', label: '강아지' },
  { assetName: 'sticker_blue_dolphin_blue.png', key: 'dolphin', label: '돌고래' },
  { assetName: 'sticker_blue_flip_phone_blue.png', key: 'flip-phone', label: '폴더폰' },
  { assetName: 'sticker_blue_flower_blue.png', key: 'flower', label: '꽃' },
  { assetName: 'sticker_blue_game_controller_blue.png', key: 'game-controller', label: '게임패드' },
  { assetName: 'sticker_blue_heart_blue.png', key: 'heart', label: '하트' },
  { assetName: 'sticker_blue_love_heart_blue.png', key: 'love-heart', label: '러브 하트' },
  { assetName: 'sticker_blue_pixel_heart_blue.png', key: 'pixel-heart', label: '픽셀 하트' },
  { assetName: 'sticker_blue_planet_blue.png', key: 'planet', label: '행성' },
  { assetName: 'sticker_blue_rabbit_white_blue.png', key: 'rabbit', label: '토끼' },
  { assetName: 'sticker_blue_shooting_star_blue.png', key: 'shooting-star', label: '유성' },
  { assetName: 'sticker_blue_smiley_blue.png', key: 'smile', label: '스마일' },
  { assetName: 'sticker_blue_speech_bubble_blue.png', key: 'speech-bubble', label: '말풍선' },
  { assetName: 'sticker_blue_star_blue.png', key: 'star', label: '별' },
  { assetName: 'sticker_blue_star_outline_blue.png', key: 'star-outline', label: '별 라인' },
  { assetName: 'sticker_blue_star_outline_blue_2.png', key: 'star-outline-2', label: '별 라인 2' }
];

const ALPHABET = 'abcdefghijklmnopqrstuvwxyz'.split('');
const NUMBERS = '0123456789'.split('');

const buildTheme = (themeKey, themeLabel, ornaments) => ({
  key: themeKey,
  label: themeLabel,
  stickers: {
    ornament: ornaments.map((o) => ({
      key: `${themeKey}-ornament-${o.key}`,
      label: o.label,
      imageSrc: stickerUrl(themeKey, 'ornament', o.assetName)
    })),
    alphabet: ALPHABET.map((c) => ({
      key: `${themeKey}-alphabet-${c}`,
      label: c.toUpperCase(),
      imageSrc: stickerUrl(themeKey, 'alphabet', `sticker_${themeKey}_letter_${c}.png`)
    })),
    number: NUMBERS.map((c) => ({
      key: `${themeKey}-number-${c}`,
      label: c,
      imageSrc: stickerUrl(themeKey, 'number', `sticker_${themeKey}_number_${c}.png`)
    }))
  }
});

export const STICKER_THEMES = [
  buildTheme('jelly', 'Jelly', JELLY_ORNAMENTS),
  buildTheme('cute', 'Cute', CUTE_ORNAMENTS),
  buildTheme('outline', 'Outline', OUTLINE_ORNAMENTS),
  buildTheme('auora', 'Auora', AUORA_ORNAMENTS),
  buildTheme('blue', 'Blue', BLUE_ORNAMENTS)
];

export const STICKER_OPTION_MAP = STICKER_THEMES.reduce((result, theme) => {
  Object.values(theme.stickers).forEach((stickerGroup) => {
    stickerGroup.forEach((option) => {
      result[option.key] = option;
    });
  });
  return result;
}, {});
